package com.exura.pages.planCreator.components.seriesViews

import androidx.compose.runtime.Composable
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.sections.SeriesEditorHeader
import com.exura.pages.planCreator.model.SeriesTypeInfo
import com.exura.ui.*
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*

@Composable
fun SeriesView(
    hasChanges: Boolean,
    isValid: Boolean,
    typeInfo: SeriesTypeInfo,
    isNewSeries: Boolean = false,
    viewMode: PlanCreatorInputMode = PlanCreatorInputMode.VIEW,
    onAction: () -> Unit = {},
    content: @Composable () -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(ExuraColors.WHITE)
            .overflow(Overflow.Auto)
    ) {
        // Enhanced header with validation-driven save button
        SeriesEditorHeader(
            hasChanges = hasChanges,
            isValid = isValid,
            typeInfo = typeInfo,
            isNewSeries = isNewSeries,
            viewMode = viewMode,
            onAction = onAction,
        )

        // Content area (scrollable)
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .weight(1f)
                .overflow(Overflow.Auto),
        ) {
            content()
        }
    }
}
